import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonDataService } from './../../common-data.service';
import { AccessGroupService } from './../../access-group.service';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { TeamReportServiceService } from '../../team-report/team-report-service.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { SessionExpiredService } from '../../../auth/session-expired.service';
import { Subject, of } from 'rxjs';
import { takeUntil, filter, take, switchMap, catchError } from 'rxjs/operators';
declare var jQuery: any;

@Component({
  selector: "navigation",
  templateUrl: "navigation.template.html",
})
export class NavigationComponent implements OnInit, OnDestroy {
  public env;
  menu_links;
  public profile: any;
  public Profiles: any;
  sideNav: boolean = true;
  store: string = environment.store;
  assessment_admin: string = environment.assessment_admin;
  app_v: string = environment.appv;
  allmaps: any;
  email_verified: string = "false";
  email: string = "";
  prev_item_index: number;
  storeNgrx: any;
  ngrxAccessGroup: any;
  userProfile: any;
  allmapslength: number;

  private destroy$ = new Subject<void>();
  private bodyClickBound = false;
  private bodyClickHandler: ((e: any) => void) | null = null;
  private errorCodesLoaded = false;

  // activeRoute() is called ~180x per change-detection cycle from the template.
  // Cache the current URL + per-URL results so each check is a map hit, recomputed
  // only when navigation actually changes the URL.
  private currentUrl = '';
  private routeMatchCache = new Map<string, boolean>();

  constructor(
    public http: HttpClient,
    private router: Router,
    public service: CommonDataService,
    public accessgroup: AccessGroupService,
    public ngrxstore: Store<any>,
    public teamReport: TeamReportServiceService,
    public oidcSecurityService: OidcSecurityService,
    private sessionExpiredService: SessionExpiredService
  ) {}

  ngOnInit() {
    this.env = environment;
    this.currentUrl = this.router.url.split('?')[0];
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.currentUrl = this.router.url.split('?')[0];
      this.routeMatchCache.clear();
    });

    this.storeNgrx = this.ngrxstore.select<any>((state) => state?.profile?.account?.default_profile);
    this.ngrxAccessGroup = this.ngrxstore.select<any>((state) => state.profile.accessGroupData);

    // Flat RxJS pipe chain — replaces nested subscribe pyramid
    this.storeNgrx.pipe(
      filter(message => !!message),
      take(1),
      switchMap(() => this.oidcSecurityService.isAuthenticated$),
      filter(({ isAuthenticated }) => isAuthenticated),
      take(1),
      switchMap(() => this.oidcSecurityService.getUserData()),
      takeUntil(this.destroy$)
    ).subscribe(userData => {
      this.profile = userData;
      this.noAuthProfile();
      const len = 15;
      if (this.profile?.email?.length > len) {
        this.email = this.profile.email.substring(0, len) + '...';
      } else {
        this.email = (this.profile?.email || '') + '...';
      }

      this.bindBodyClick();

      setTimeout(() => {
        this.toggleMenu();
      }, 500);
    });

    this.storeNgrx.pipe(
      takeUntil(this.destroy$)
    ).subscribe(message => {
      this.userProfile = message;
    });

    this.ngrxAccessGroup.pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      message => {
        if (message) {
          this.menu_links = message;
          this.email_verified = 'true';
          // Learner maps no longer come from the access group — they're read from
          // state.profile.account.assigned_learner_maps in the subscription below.
          // One-shot side fetch: don't refire on every access-group emission.
          if (this.menu_links.main_menu?.shop === true && !this.errorCodesLoaded) {
            this.errorCodesLoaded = true;
            this.http.get(`${environment.assessment_admin}api/v1/public/stripe_decline_codes.json`)
              .pipe(takeUntil(this.destroy$))
              .subscribe(res => {
                localStorage.setItem('error_codes', JSON.stringify(res));
              });
          }
        }
      },
      err => {
        if (err.status == 412) {
          this.email_verified = 'false';
        }
      }
    );

    // Fetched over HTTP rather than read from the NgRx account slice: the store
    // isn't reliably populated by the time the nav initialises (v16.1.997). Gated on
    // isAuthenticated$ so it can't fire during the Cognito callback, where the premature
    // 401 was read as an expired session and popped the Session Expired dialog (v16.2.085).
    // Production reverted to the store in its v16.2.002; kept on HTTP here deliberately.
    this.oidcSecurityService.isAuthenticated$.pipe(
      filter(({ isAuthenticated }) => isAuthenticated),
      take(1),
      switchMap(() => this.http.get<any>(`${environment.profileURL}/api/v1/users/account`).pipe(catchError(() => of(null)))),
      takeUntil(this.destroy$)
    ).subscribe(account => {
      this.allmaps = [];
      const assignedLearnerMaps = account?.assigned_learner_maps;
      if (!assignedLearnerMaps) { return; }
      const maps: [string, any][] = Array.isArray(assignedLearnerMaps)
        ? assignedLearnerMaps.map((item: any) => [item.id || item.value, item])
        : Object.entries(assignedLearnerMaps);
      maps.forEach(([key, map]) => {
        // No EXCLUDED_LEARNER_MAP_TITLES filter here: v16.1.998 deliberately shows
        // every assigned map in the side nav. The dashboard's "Current Learner Map"
        // card still filters, since it features one map and "My Profile" isn't one.
        if (map?.title) {
          const normalizedMap = { ...map, value: map.value || map.id || key };
          this.allmaps.push([key, normalizedMap]);
        }
      });
      this.allmapslength = this.allmaps.length;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.bodyClickHandler) {
      jQuery('body').off('click', this.bodyClickHandler);
      this.bodyClickHandler = null;
      this.bodyClickBound = false;
    }
  }

  activeRoute(routename: string): boolean {
    // The template passes `activeRoute(item[1]?.value)` for the learner-map
    // children, so this is called with undefined before the maps load. The old
    // indexOf coerced that to the string "undefined" and quietly returned false;
    // string methods below would throw instead, and a throw here breaks change
    // detection for the whole menu — the parent item then never gets `active`
    // and its submenu won't open. Non-strings return false, as before.
    if (typeof routename !== 'string' || !routename) { return false; }
    const cached = this.routeMatchCache.get(routename);
    if (cached !== undefined) { return cached; }
    // Match whole path segments, not raw substrings. A plain indexOf lit up the
    // 'tools' menu on /learner-maps/toolset — "toolset" starts with "tools" — so
    // two sidebar sections opened at once. Anchoring both ends on '/' also makes
    // the old numeric special-case redundant: '/8/' can't match '/18/'.
    const url = this.currentUrl.endsWith('/') ? this.currentUrl : this.currentUrl + '/';
    const needle = routename.startsWith('/') ? routename : '/' + routename;
    const match = url.includes(needle + '/');
    this.routeMatchCache.set(routename, match);
    return match;
  }

  trackByMap(index: number, item: any): any { return item?.[0] ?? index; }

  public openNav() {
    this.sideNav = !this.sideNav;
  }

  public noAuthProfile() {
    if (!this.profile.name && !this.profile.email) {
      if (this.userProfile) {
        this.Profiles = this.userProfile;
        if (localStorage.getItem("impersonation") == "true") {
          localStorage.setItem("email", this.Profiles.email);
        }
        if (!this.Profiles.identity.picture_url) {
          this.Profiles.identity.picture_url = localStorage.getItem("picture_url");
        }
      } else {
        $(".profile-error").show();
      }
    }
  }

  public toggleNavigation() {
    $("body").toggleClass("mini-navbar");
    if (
      !$("body").hasClass("mini-navbar") ||
      $("body").hasClass("body-small")
    ) {
      $("#side-menu").hide();
      setTimeout(function () {
        $("#side-menu").fadeIn(500);
      }, 100);
    } else {
      $("#side-menu").removeAttr("style");
    }

    if ($(".owl-carousel").length) {
      setTimeout(function () {
        var owl = $(".owl-carousel").data("owlCarousel");
        owl.updateVars();
      }, 500);
    }
  }

  public toggleMenu() {
    $('.scroll-bar>li ul.nav.nav-second-level').removeClass('in');
    let removeIn = () => {
      $('.scroll-bar>li').removeClass('in');
      let all_item = document.querySelectorAll('.scroll-bar>li');
      all_item.forEach((item) => {
        if (item.classList.contains('active')) {
          item.classList.add('active--clr');
          item.querySelectorAll('ul.nav.nav-second-level')[0].classList.remove('in');
        }
      });
    };
    setTimeout(() => {
      let all_item = document.querySelectorAll('.scroll-bar>li');
      all_item.forEach((item, i) => {
        if (item.classList.contains('active')) {
          if (i == this.prev_item_index) {
            this.prev_item_index = all_item.length + 1;
            removeIn();
          } else {
            this.prev_item_index = i;
            item.querySelectorAll('ul.nav.nav-second-level')[0].classList.add('in');
            item.classList.remove('active--clr');
          }
        }
      });
    }, 50);
  }

  public myTeamsDefaultView() {
    this.teamReport.defaultMyTeamsView.next(true);
  }

  public logout(): void {
    // Preserve CN data across logout
    const cnFrameworks = localStorage.getItem('CN_FRAMEWORKS');

    // Prevent session-expired popup from firing on intentional logout
    this.sessionExpiredService.popupShown = true;
    // Clear local OIDC state
    this.oidcSecurityService.logoffLocal();
    localStorage.clear();
    if (cnFrameworks) {
      localStorage.setItem('CN_FRAMEWORKS', cnFrameworks);
    }
    if (window.sessionStorage) {
      window.sessionStorage.clear();
    }

    // Redirect to Cognito logout to end server-side session
    const redirectUri = encodeURIComponent(window.location.origin);
    window.location.href = `${environment.cognito.domain}/logout?client_id=${environment.cognito.clientId}&redirect_uri=${redirectUri}&response_type=${environment.cognito.responseType}`;
  }

  public getSpaceClass(fetureName: string) {
    if (fetureName == 'learnermap') {
      if (!this.menu_links?.main_menu?.orgs && !this.menu_links?.main_menu?.manage_profiles && !this.menu_links?.menu_account?.account_downloads) {
        return true;
      }
    }
    if (fetureName == 'store') {
      if (!this.menu_links?.main_menu?.orgs && !this.menu_links?.main_menu?.manage_profiles && !this.menu_links?.menu_account?.account_downloads && (!this.allmapslength || this.allmapslength == 0)) {
        return true;
      }
    }
  }

  private bindBodyClick() {
    if (this.bodyClickBound) return;
    this.bodyClickBound = true;
    // Keep a handler reference so ngOnDestroy can unbind it (was a listener leak).
    this.bodyClickHandler = (e: any) => {
      if (e.target.id == "user-nav" || e.target.id == "sidenav") {
        return false;
      }
      this.sideNav = true;
    };
    jQuery('body').on('click', this.bodyClickHandler);
  }
}
